/**
 * Check if this code is running in a browser.
 * @return {boolean} true if this is a web browser
 */
function isBrowser() {
  return typeof jest !== 'undefined' ? false : typeof window !== 'undefined';
}

var Browser = {
  isBrowser: isBrowser
};
export default Browser;